module.exports = __webpack_public_path__ + "static/media/reward.a54e38fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/reward.svg
// module id = 1195
// module chunks = 0